export default "__VITE_ASSET__Dt7Pf7YP__"